import React from "react";
import { Activity, Bot, History, MessageSquare } from "lucide-react";
import MerkezHubShell from "@/components/MerkezHubShell";

const TABS = [
    { id: "ozet", label: "Özet", icon: Activity },
    { id: "audit", label: "Denetim İzleri", icon: History },
    { id: "whatsapp", label: "WhatsApp Logları", icon: MessageSquare },
    { id: "ai-gorevler", label: "AI Görevleri", icon: Bot },
    { id: "ai-oneriler", label: "AI Önerileri", icon: Bot },
];

export default function SistemGunluguMerkezLayout() {
    return (
        <MerkezHubShell
            title="Sistem Günlüğü"
            subtitle="Denetim izleri, WhatsApp mesaj logları ve AI görev/öneri kayıtları — salt okuma izleme merkezi."
            badge="Sistem · Denetim"
            basePath="/yeni/sistem-gunlugu"
            tabs={TABS}
        />
    );
}
